export default __webpack_public_path__ + "eb8c05a70ef6d896fbdb4f061397f6b8.png";